var xaoi = {}

function json_encode(o){return JSON.stringify(o)}
function json_decode(s){return JSON.parse(s)}

xaoi.time = function(o){
	var t = o||new Date();
	return parseInt(t.getTime()/1000);
}

xaoi.date = function(str){
	var t;
	switch(arguments.length){
		case 1:
			t = new Date();
		break;
		case 2:
			if(arguments[1] >= 0){
				t = new Date(parseInt(arguments[1]+'000'));
			}else if(arguments[1] < 0){
				t = Math.abs(arguments[1]);
				var d = parseInt(t / 60 / 60 / 24);
				var H = parseInt(t / 60 / 60 % 24);
				var i = parseInt(t / 60 % 60);
				var s = parseInt(t % 60);
				str = str.replace(/d([^dHis]*)/g,d > 0?d+'$1':'');
				str = str.replace(/H([^dHis]*)/g,H > 0?H+'$1':'');
				str = str.replace(/i([^dHis]*)/g,i > 0?i+'$1':'');
				str = str.replace(/s([^dHis]*)/g,s > 0?s+'$1':'');
				return str;
			}else{
				return '';
			}
		break;
	}
	var Y = t.getFullYear();
	var y = t.getFullYear().toString().substr(2);
	var m = t.getMonth()+1;
	var d = t.getDate();
	var H = t.getHours();
	var i = t.getMinutes();
	var s = t.getSeconds();
	if(m < 10)m = '0'+m;
	if(d < 10)d = '0'+d;
	if(H < 10)H = '0'+H;
	if(i < 10)i = '0'+i;
	if(s < 10)s = '0'+s;
	str = str.replace(/Y/g,Y);
	str = str.replace(/y/g,y);
	str = str.replace(/m/g,m);
	str = str.replace(/d/g,d);
	str = str.replace(/H/g,H);
	str = str.replace(/i/g,i);
	str = str.replace(/s/g,s);
	return str;
}

xaoi.strtotime = function (str){
    var _arr = str.split(' ');
    var _day = _arr[0].split('-');
    _arr[1] = (_arr[1] == null) ? '0:0:0' :_arr[1];
    var _time = _arr[1].split(':');
    for (var i = _day.length - 1; i >= 0; i--) {
        _day[i] = isNaN(parseInt(_day[i])) ? 0 :parseInt(_day[i]);
    };
    for (var i = _time.length - 1; i >= 0; i--) {
        _time[i] = isNaN(parseInt(_time[i])) ? 0 :parseInt(_time[i]);
    };
    var _temp = new Date(_day[0],_day[1]-1,_day[2],_time[0],_time[1],_time[2]);
    return _temp.getTime() / 1000;
}

xaoi.session = function(){
	switch(arguments.length){
		case 1:
			var r = sessionStorage.getItem((xaoi.session.prefix||'')+arguments[0]);
			return r?JSON.parse(r):r;
		break;
		case 2:
			if(arguments[1] === null){
				sessionStorage.removeItem((xaoi.session.prefix||'')+arguments[0]);
			}else{
				sessionStorage.setItem((xaoi.session.prefix||'')+arguments[0],JSON.stringify(arguments[1]))
			}
		break;
	}
}

xaoi.store = function(){
	switch(arguments.length){
		case 1:
			var r = localStorage.getItem((xaoi.store.prefix||'')+arguments[0]);
			return r?JSON.parse(r):r;
		break;
		case 2:
			if(arguments[1] === null){
				localStorage.removeItem((xaoi.store.prefix||'')+arguments[0]);
			}else{
				localStorage.setItem((xaoi.store.prefix||'')+arguments[0],JSON.stringify(arguments[1]))
			}
		break;
	}
}

xaoi.ajax = function(){
	var call = function(d,fn){
		if(Object.prototype.toString.call(d) === '[object Promise]'){
			d.then(function(d){
				fn(d)
			}).catch(function(e){
				fn([false,e])
			})
		}else{
			fn(d)
		}
	}
	var tofd = function(post){
		var fd = new FormData();
		var f = function(n,d){
			var _n
			for(var i in d){
				_n = n+'_'+i
				switch(Object.prototype.toString.call(d[i])){
					case '[object Object]':
					case '[object Array]':
						d[i] = f(_n,d[i])
					break;
					case '[object File]':
						fd.append(_n, d[i]);
						d[i] = _n;
					break;
				}
			}
			return d;
		}
		for(var i in post){
			switch(Object.prototype.toString.call(post[i])){
				case '[object Object]':
				case '[object Array]':
					fd.append(i, json_encode(f('file_'+i,post[i])));
				break;
				case '[object File]':
				case '[object Number]':
				case '[object String]':
				case '[object Null]':
				case '[object Boolean]':
					fd.append(i, post[i]);
				break;
			}
		}
		return fd;
	}
	var get = function(obj){
		return new Promise(function(ok){
			var xhr = new XMLHttpRequest();
			obj.xhr = xhr;
			var url = obj.url;
			if(obj.query){
				if(url.indexOf('?') === -1)url += '?';
				if(url.length && url[url.length-1] !== '&' && url[url.length-1] !== '?')url += '&';
				var lis = [];
				for(var i in obj.query)lis.push(encodeURIComponent(i)+'='+encodeURIComponent(obj.query[i]));
				url += lis.join('&');
			}
			xhr.open(obj.type,url,true);
			var h = obj.header();
			for(var i in h)xhr.setRequestHeader(i,h[i]);
			xhr.addEventListener('load',function(){
				if(xhr.readyState==4){
					if(xhr.status==200){
						var t
						try{
							t=JSON.parse(xhr.responseText);
						}catch(ex){
							ok(false);
							return;
						}
						ok(t);
					}else{
						ok(false);
					}
				}
			});
			switch(Object.prototype.toString.call(obj.data)){
				case '[object Object]':
					var s = false;
					for(var i in obj.data){s = true;break;}
					if(s){
						xhr.send(tofd(obj.data));
					}else{
						xhr.send();
					}
				break;
				case '[object Array]':
					xhr.send(JSON.stringify(obj.data));
				break;
				case '[object String]':
					xhr.send(obj.data);
				break;
				default:
					xhr.send();
				break;
			}
		});
	}
	var fn = function(k,v){
		if(typeof k === 'function'){
			var d = {
				req:[k].concat(this.req),
				res:this.res.concat(),
			}
			if(typeof v === 'function')d.res.unshift(v);
			return fn.bind(d);
		}else{
			var args = this;
			return new Promise(function(ok){
				var obj = {
					type:'post',
					url:k,
					query:'',
					data:v,
					header:function(){
						var d = {};
						return function(){
							switch(arguments.length){
								case 0:
									return d;
								break;
								case 1:
									return obj.xhr.getResponseHeader(arguments[0]);
								break;
								case 2:
									d[arguments[0]] = arguments[1];
								break;
							}
						}
					}()
				}
				var arrfn = [];
				var f = function(i,fn){
					if(args.req.length == i){
						fn();
						return;
					}
					var r = args.req[i].apply(obj);
					call(r,function(d){
						if(typeof d === 'function'){
							arrfn.unshift(d);
							f(i+1,fn)
						}else if(d){
							fn(d);
						}else{
							f(i+1,fn)
						}
					});
				}
				f(0,function(d){
					if(d){
						ok(d);
						return;
					}
					var f2 = function(i,fn){
						if(arrfn.length == i){
							fn();
							return;
						}
						var r = arrfn[i].apply(obj);
						call(r,function(d){
							if(d){
								fn(d);
							}else{
								f2(i+1,fn)
							}
						});
					}
					f2(0,function(d){
						if(d){
							ok(d);
							return;
						}
						get(obj).then(function(res){
							if(typeof res !== 'object')res = [res];
							arrfn = [];
							var f = function(i,fn){
								if(args.res.length == i){
									fn();
									return;
								}
								var r = args.res[i].call(obj,res);
								call(r,function(d){
									if(typeof d === 'function'){
										arrfn.unshift(d);
										f(i+1,fn)
									}else if(d){
										fn(d);
									}else{
										f(i+1,fn)
									}
								});
							}
							f(0,function(d){
								if(d){
									ok(d);
									return;
								}
								var f2 = function(i,fn){
									if(arrfn.length == i){
										fn();
										return;
									}
									var r = arrfn[i].apply(obj,res);
									call(r,function(d){
										if(d){
											fn(d);
										}else{
											f2(i+1,fn)
										}
									});
								}
								f2(0,function(d){
									if(d){
										ok(d);
										return;
									}
									ok(res);
								})
							})
						});
					})
				})
			});
		}
	}
	return fn.bind({req:[],res:[]});
}()

function object_clone(o){
	if(Object.prototype.toString.call(o) === '[object Object]'){
		var n = {};
		for(var i in o)n[i] = object_clone(o[i]);
		return n;
	}else if(Object.prototype.toString.call(o) === '[object Array]'){
		var n = [];
		for(var i = 0,s = o.length;i!==s;++i)n.push(object_clone(o[i]));
		return n;
	}else{
		return o;
	}
}

xaoi.object_clone = object_clone;


// WebSocket
xaoi.ws = function(url){
	var fn = function(){
		var ws = new WebSocket(url);
		ws.onopen = function(e){
			if(typeof fn.onopen === 'function')fn.onopen(e)
		};
		ws.onmessage = function(e){
			var d;
			try{d=JSON.parse(e.data);}catch(e){};
			if(d && typeof d[0] !== 'undefined'){
				var k = d.shift();
				if(typeof fn[k] === 'function')fn[k].apply(null,d)
			}
		};
		ws.onerror = function(e){
			if(typeof fn.onerror === 'function')fn.onerror(e)
		};
		ws.onclose = function(e){
			if(typeof fn.onclose === 'function')fn.onclose(e)
		};

		fn.send = function(){

			// var args = [];
			// console.log(arguments)
			/*for(var i in arguments)args.push(arguments[i]);
			
			if(ws.readyState === 1)
				ws.send(json_encode(args));
			else
				console.log('连接断开，请刷新页面再试！');*/

			ws.send(JSON.stringify(arguments[0]));
		};

		fn.close = function(){
			ws.close();
		};
	}
	
	return fn;
};

export default xaoi;